<template>
  <form class="row" @submit.prevent="onSubmit">
    <div class="medium-12 columns">
      <label :class="{ error: $v.eventName.$error }">
        {{ $t('EVENTS.FORM.LABEL_NAME') }}
        <input
          v-model.trim="eventName"
          type="text"
          name="event_name"
          :placeholder="$t('EVENTS.FORM.PLACEHOLDER_NAME')"
          @input="$v.eventName.$touch"
        />
        <span v-if="$v.eventName.$error" class="message">
          {{ $t('EVENTS.FORM.ERROR_NAME') }}
        </span>
      </label>

      <label :class="{ error: $v.eventDescription.$error }">
        {{ $t('EVENTS.FORM.LABEL_DESCRIPTION') }}
        <input
          v-model.trim="eventDescription"
          type="text"
          name="event_description"
          :placeholder="$t('EVENTS.FORM.PLACEHOLDER_DESCRIPTION')"
          @input="$v.eventDescription.$touch"
        />
        <span v-if="$v.eventDescription.$error" class="message">
          {{ $t('EVENTS.FORM.ERROR_DESCRIPTION') }}
        </span>
      </label>
    </div>

    <div class="modal-footer">
      <div class="medium-12 columns">
        <woot-button
          :disabled="$v.$invalid || isSubmitting"
          :loading="isSubmitting"
        >
          {{ $t('EVENTS.FORM.BTN_SUBMIT') }}
        </woot-button>
        <woot-button class="button clear" @click.prevent="$emit('cancel')">
          {{ $t('EVENTS.FORM.BTN_CANCEL') }}
        </woot-button>
      </div>
    </div>
  </form>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      eventName: this.value.event_name || '',
      eventDescription: this.value.event_description || '',
    };
  },
  validations: {
    eventName: { required },
    eventDescription: { required },
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.$emit('submit', {
        event_name: this.eventName,
        event_description: this.eventDescription,
      });
    },
  },
};
</script>
